import type { MotionEffectsReactions } from './types'
import type { IMotionEffectsInit } from 'feature-motion-effects'
import { optional, withDependencies } from '@wix/thunderbolt-ioc'
import { MotionEffectsInitSymbol, MotionEffectsManager } from 'feature-motion-effects'

export const motionEffectsReactions = withDependencies(
	[optional(MotionEffectsInitSymbol)],
	(motionEffects: IMotionEffectsInit): MotionEffectsReactions => {
		let motionEffectsManager: MotionEffectsManager | undefined

		motionEffects?.getInstance().then((manager) => {
			motionEffectsManager = manager
		})

		const play: MotionEffectsReactions['play'] = (effectId, targetCompId) => {
			motionEffectsManager?.trigger({ play: [{ effectId, targetId: targetCompId }] })
		}

		const scrub: MotionEffectsReactions['scrub'] = (effectScrubMap) => {
			motionEffectsManager?.trigger({ scrub: effectScrubMap })
		}

		return {
			play,
			scrub,
		}
	}
)
